import UIAccordionGroup from './js/accordionGroup';
import UIAccordion from './js/accordions';
import Commite from './js/commite';
import UIPopup from './js/popup';
import RandomImager from './js/randomImager';
import Slider from './js/slider';
import './scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
    RandomImager.init();
    UIPopup.init();
    Slider.init();
    Commite.init();
    UIAccordionGroup.init();
    UIAccordion.init();

    /**
     * Header size css var
     */
    const setHeaderSize = () => {
        const header = document.getElementById('header');
        document.body.style.setProperty('--header-h', `${header.offsetHeight}px`);
    };

    setHeaderSize();
    window.addEventListener('resize', () => setHeaderSize());
});
